import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { BillableMetric } from 'src/features/billableMetrics/utils/types';

const RESOURCE = '/subscriptions/billable-metric/:metricId/';

type QueryFnType = typeof queryFn;

interface DTO {
    metricId: string;
}
const queryFn = ({ metricId }: DTO): Promise<BillableMetric> => {
    return axios.get(formatResourcePath(RESOURCE, { metricId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetBillableMetric, RESOURCE as BILLABLE_METRIC_RESOURCE };
